module.exports = __webpack_public_path__ + "img/1561057799.511037d1.jpg";